import { render, staticRenderFns } from "./LegacyOverlayPreview.vue?vue&type=template&id=139ac47c&scoped=true"
import script from "./LegacyOverlayPreview.vue?vue&type=script&lang=js"
export * from "./LegacyOverlayPreview.vue?vue&type=script&lang=js"
import style0 from "./LegacyOverlayPreview.vue?vue&type=style&index=0&id=139ac47c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139ac47c",
  null
  
)

export default component.exports